import React, {useMemo} from 'react'
import Text from '../../../components/text/Text'
import useQueryCopierList from '../../../hooks/api/copier/useQueryCopier'
import {ICopier} from '../../../apis/copier/copier'
import CopierTable from '../copyTrading/copier/CopierTable'

interface IProps {
    className?: string
    userId?: string
}

const UserCopyTradingContainer: React.FC<IProps> = ({className, userId}) => {
    const {data} = useQueryCopierList(userId)

    const copierList = useMemo(() => {
        const list: ICopier[] = []
        data?.pages?.map(page =>
            page?.map(item => {
                if (item?.status === 'running') {
                    list.unshift(item)
                } else {
                    list.push(item)
                }
            }),
        )
        return list
    }, [data])

    return (
        <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
            <Text className={'text-h3'}>Copy Trading</Text>
            <div className={'mt-[30px]'}>
                <CopierTable data={copierList} />
            </div>
        </div>
    )
}

export default UserCopyTradingContainer
